export const isHTMLString = (str: string): boolean =>
  /<[a-z][\s\S]*>/i.test(str);
